// extracted by mini-css-extract-plugin
export default {"addContainer":"styles-module__addContainer__src-labstep-web-components-Permission-Table-_fsm1P"};